import React, { useState } from "react";
import { Link } from "react-router-dom";

import db, { auth, storage } from "../firebase";

import { notify } from "react-notify-toast";
import { CircularProgress } from "@material-ui/core";

const Signup = () => {
  const [outlets, setOutlets] = useState(0);
  const [bName, setBName] = useState("");
  const [bAdd, setBAdd] = useState("");
  const [bNumber, setBNumber] = useState(Number);
  const [bEmail, setBEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userName, setUserName] = useState("");
  const [error, seterror] = useState(false);
  const [loading, setloading] = useState(false);
  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //
    re.test(String(email).toLowerCase()) ? setBEmail(email) : seterror("email");
    return re.test(String(email).toLowerCase());
  };
  const SignupHandler = async () => {
    if (outlets == 0) {
      notify.show("Please select Outlets", "error");
      return;
    }
    if (bAdd === "") {
      notify.show("Please enter branch Address", "error");
      return;
    }
    if (bName === "") {
      notify.show("Please enter restaurent name", "error");
      return;
    }
    if (bNumber === "") {
      notify.show("Please enter brand number", "error");
    }
    if (userName == "") {
      notify.show("Please enter Your name", "error");
      return;
    }
    if (password.length < 6) {
      notify.show("Password must be at least 6 characters", "error");
      return;
    }

    setloading(true);
    await db
      .collection("Merchant")
      .add({
        outlets: outlets,
        brandName: bName,
        brandAddress: bAdd,
        brandNumber: bName,
      })
      .then(async (doc) => {
        doc.update({ uid: doc.id });
        db.collection("users").add({
          name: userName,
          email: bEmail,
          password: password,
          of: doc.id,
          role: "Merchant",
          user: false,
          uid: doc.id,
        });
        let payload = {
          name: userName,
          email: bEmail,
          password: password,
          of: doc.id,
          role: "Merchant",
          outlets: outlets,
          brandName: bName,
          brandAddress: bAdd,
          brandNumber: bName,
          user: false,
          uid: doc.id,
        };
        localStorage.setItem("Ubytes", JSON.stringify(payload));
        notify.show("Signup successful!", "success");
        setloading(false);
        window.location = window.origin + "/dashboard";
      });
  };

  return (
    <div className="login-main">
      <div className="login-body">
        <div className="login-branding">
          <i
            class="fas fa-hamburger"
            style={{ color: "lightblue", marginRight: "10px" }}
          ></i>
          <p>uBytes</p>
        </div>
        <br></br>
        <div className="login-form-section">
          <strong>
            <p className="login-title">Try uBytes free for 30 days</p>
          </strong>
          <br></br>
          <p style={{ fontSize: "small" }}>
            No credit card required. Cancel anytime
          </p>
          <br></br>
        </div>
        <div className="login-form">
          <div className="login-form-section">
            <p>Your Name: </p>

            <input
              type="name"
              placeholder="Enter your name"
              className={
                userName === "" ? "login-form-input-e" : "login-form-input"
              }
              onChange={(e) => setUserName(e.target.value)}
              value={userName}
              required
            />
          </div>
          <br />
          <div className="login-form-section">
            <p>What's the name of your restaurent? *</p>

            <input
              type="text"
              placeholder="Enter your restaurent name"
              className={
                bName === "" ? "login-form-input-e" : "login-form-input"
              }
              onChange={(e) => setBName(e.target.value)}
              value={bName}
              required
            />
          </div>
          <br />
          <div className="login-form-section">
            <p>How many outlets do you have? *</p>
            <select
              className={
                outlets === 0 ? "login-form-input-e" : "login-form-input"
              }
              onChange={(e) => setOutlets(e.target.value)}
              value={outlets}
              required
            >
              <option value="0">Select Outlets</option>
              <option value="1">1 outlet</option>
              <option value="2">2 - 5 outlets</option>
              <option value="3">5 - 10 outlets</option>
              <option value="4">10+ outlets</option>
            </select>
          </div>
          <br />
          <div className="login-form-section">
            <p>Brand Number</p>
            <input
              onChange={(e) => setBNumber(e.target.value)}
              placeholder="Brand Number"
              className={
                bNumber === "" ? "login-form-input-e" : "login-form-input"
              }
              type="phonenumber"
              value={bNumber}
              required
            />
          </div>
          <br />
          <div className="login-form-section">
            <p>Brand Address</p>
            <input
              onChange={(e) => setBAdd(e.target.value)}
              placeholder="Brand Address"
              className={
                bAdd === "" ? "login-form-input-e" : "login-form-input"
              }
              type="address"
              value={bAdd}
              required
            />
          </div>
          <br />

          <div className="login-form-section">
            <p>Brand Email</p>
            <input
              onBlur={() => validateEmail(bEmail)}
              onChange={(e) => setBEmail(e.target.value)}
              placeholder="Brand Email"
              className={
                bEmail === "" ? "login-form-input-e" : "login-form-input"
              }
              type="email"
              value={bEmail}
              required
            />
          </div>
          <br />
          <div className="login-form-section">
            <p>Password</p>
            <input
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className={
                password.length < 6 ? "login-form-input-e" : "login-form-input"
              }
              type="password"
              value={password}
              required
            />
          </div>
          <div className="login-form-section">
            <button className="login-button" onClick={SignupHandler}>
              {!loading ? (
                "Signup"
              ) : (
                <CircularProgress color="grey"></CircularProgress>
              )}
            </button>
          </div>
          <br></br>

          <div className="login-form-section">
            <p style={{ textAlign: "center" }}>
              Already have an account? <Link to="/login">Login</Link>
            </p>
          </div>
        </div>
      </div>

      <div className="login-right-section"></div>
    </div>
  );
};

export default Signup;
